// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"CanceledSubscriptions_contentComponent__hKBxt","tableContainer":"CanceledSubscriptions_tableContainer__3-feK","totalRow":"CanceledSubscriptions_totalRow__3c1Hc"};